<template>
  <v-card class="header">
    <CustomerUserDesktopNav
      v-if="$vuetify.breakpoint.width > 960"
      :showAdmin="showAdmin"
      :showCaseLibrary="showCaseLibrary"
      :navTabsOptional="navTabsOptional"
      :hasMultiView="hasMultiView"
      :hasSearchView="hasSearchView"
      :isLoggedIn="isLoggedIn"
      :queryString="shareQueryString"
      :externalCloudCases="externalCloudCases"
    />
    <CustomerUserMobileNav
      v-else
      :showAdmin="showAdmin"
      :showCaseLibrary="showCaseLibrary"
      :navTabsOptional="navTabsOptional"
      :hasMultiView="hasMultiView"
      :hasSearchView="hasSearchView"
      :isLoggedIn="isLoggedIn"
      :queryString="shareQueryString"
    />
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import CustomerUserDesktopNav from './CustomerUserDesktopNav.vue'
import CustomerUserMobileNav from './CustomerUserMobileNav.vue'
import { mapGetters, mapState } from 'vuex'

export default defineComponent({
  name: 'CustomerUserNav',
  components: {
    CustomerUserDesktopNav,
    CustomerUserMobileNav,
  },
  props: {
    showAdmin: {
      type: Boolean,
      required: true,
    },
    showCaseLibrary: {
      type: Boolean,
      required: true,
    },
    navTabsOptional: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters('Environment', ['hasMultiView', 'hasSearchView']),
    ...mapState('Security', ['isLoggedIn', 'isTokenAuthenticated']),
    ...mapState('ExternalCases', ['shareQueryString']),
    externalCloudCases() {
      return this.isTokenAuthenticated
    },
  },
})
</script>
<style lang="scss">
.mobile-customer-logo {
  height: 48px !important;
}
</style>
